/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { INVOICE_CLASSIFICATION_OPTIONS } from 'domain/finance/invoice/useInvoiceService';

const InvoiceClassificationDropdown = (props: DefaultInputPropTypes<string>) => {
  return (
    <EnumDropdown
      options={INVOICE_CLASSIFICATION_OPTIONS}
      label="Purchase Classification"
      placeholder="Select Purchase Classification"
      {...props}
    />
  );
};

export default InvoiceClassificationDropdown;
